import { Layers, Workflow, Car, Users, ScrollText, Bot } from "lucide-react";
import { Eyebrow, Reveal } from "./Reveal";

const MODULES = [
    { icon: Layers, name: "Floor Plan", desc: "Live desk maps for Floors 2, 3, 4, and 6" },
    { icon: Workflow, name: "Desk Workflow", desc: "Allocation pipeline from request to IT setup" },
    { icon: Car, name: "Car Booking", desc: "Transport with auto-dispatched vendor emails" },
    { icon: Users, name: "People", desc: "New joiners, leavers, role changes" },
    { icon: ScrollText, name: "Audit Trail", desc: "Every platform action, logged and searchable" },
    { icon: Bot, name: "Finance & Admin Chatbot", desc: "AI answers from IDeaS's own documents" },
];

export function Modules() {
    return (
        <section data-testid="modules-section" className="relative py-20 sm:py-28 border-y border-[var(--line)]">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <Reveal className="max-w-2xl mb-12 sm:mb-16">
                    <Eyebrow>03 · Modules</Eyebrow>
                    <h2 className="mt-3 font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[var(--ink)]">
                        Everything the IDeaS Pune Office Runs On
                    </h2>
                    <p className="mt-4 text-base sm:text-lg text-[var(--ink-2)]">
                        Six modules. One login. Built for the Admin and Finance team.
                    </p>
                </Reveal>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6">
                    {MODULES.map((m, i) => {
                        const Icon = m.icon;
                        return (
                            <Reveal key={m.name} delay={i * 0.1}>
                                <div
                                    data-testid={`module-card-${i + 1}`}
                                    className="group relative h-full bg-[var(--paper)] border border-[var(--line)] rounded-xl p-6 sm:p-7 shadow-[0_4px_20px_-4px_rgba(15,23,42,0.05)] hover:shadow-[0_14px_34px_-8px_rgba(212,169,60,0.15)] hover:border-[var(--peach)] hover:-translate-y-[3px] transition-[transform,box-shadow,border-color] duration-200"
                                >
                                    <div className="w-11 h-11 rounded-lg bg-[var(--accent-soft)] border border-[var(--accent)]/15 grid place-items-center text-[var(--accent)] transition-transform duration-200 group-hover:scale-110">
                                        <Icon size={20} strokeWidth={1.8} />
                                    </div>
                                    <h3 className="mt-5 font-display font-bold text-lg tracking-tight text-[var(--ink)]">{m.name}</h3>
                                    <p className="mt-1.5 text-sm leading-relaxed text-[var(--ink-3)]">{m.desc}</p>
                                    <span className="absolute top-5 right-5 mono text-[10px] tracking-[0.2em] text-[#C7B584]">
                                        M-{String(i + 1).padStart(2, "0")}
                                    </span>
                                </div>
                            </Reveal>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
